import { createSlice } from "@reduxjs/toolkit";
import { fetchGRN } from "./thunk";

interface GRNState {
  GRNList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: GRNState = {
  GRNList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const GRNSlice = createSlice({
  name: "GRN",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGRN.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGRN.fulfilled, (state, action) => {
        state.loading = false;
        state.GRNList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchGRN.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch FieldEngineerList Log";
      });
  },
});

export default GRNSlice.reducer;
